import {AfterViewInit, Component} from '@angular/core';
import {AppService} from '../../services/app.service';

@Component({
  selector: 'pm-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements AfterViewInit {

  constructor(
    private app: AppService
  ) {
    app.setTitle('Search');
  }

  ngAfterViewInit(): void {
    // parallax-scroll
    $(document).ready(() => {
      if ($(window).width() > 1200) {
        $(() => {
          $('.download_payouttt_container').parallaxScroll({friction: .10, direction: 'vertical'});
        });
      }
    });

    $('.myaccordion .brand-header').click(function() {
      $(this).siblings().slideToggle();
      $(this).parents('.myaccordion').toggleClass('active');
    });
    $('.refine-sec-top .brand-header-top').click(function() {
      $(this).siblings().slideToggle();
      $('.refine-sec-top').toggleClass('active');
    });
    // ==================================== Select DropDown Js ====================================
    $(document).ready(() => {
      $('select').niceSelect();
    });
  }

}
